import React from 'react';
import { MenuItem, TextField, Tooltip } from '@mui/material';

export const EFFORT_OPTIONS: { id: string; label: string; hint: string }[] = [
  { id: 'default', label: 'Default', hint: 'Medium in App Builder, the model’s own default in chat.' },
  { id: 'low', label: 'Low', hint: 'Quickest and cheapest. Fine for small edits and simple questions.' },
  { id: 'medium', label: 'Medium', hint: 'Plans before writing. A good fit for most builds.' },
  { id: 'high', label: 'High', hint: 'Thinks longer. Slower and costs more, and leaves less room for code in one reply.' },
  { id: 'max', label: 'Max', hint: 'Deepest reasoning. Can use much of the reply limit on thinking before any code.' },
];

interface Props {
  value?: string | null;
  onChange: (effort: string | null) => void;
  /** App Builder resolves Default to Medium; say so in the closed field. */
  isBuilder?: boolean;
  disabled?: boolean;
}

/** Claude thinking-effort level for the next send. Only meaningful for models in CLAUDE_EFFORT_MODELS. */
export const EffortPicker: React.FC<Props> = ({ value, onChange, isBuilder, disabled }) => {
  const current = value || 'default';
  return (
    <Tooltip
      placement="top"
      arrow
      title="How long Claude thinks before it answers. Thinking counts toward the reply’s output limit and your credits."
    >
      <TextField
        select
        size="small"
        label="Thinking"
        value={current}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value === 'default' ? null : e.target.value)}
        SelectProps={{
          renderValue: (v) => {
            const opt = EFFORT_OPTIONS.find((o) => o.id === v);
            if (v === 'default') return isBuilder ? 'Default (Medium)' : 'Default';
            return opt?.label || String(v);
          },
        }}
        sx={{ minWidth: 132, flexShrink: 0 }}
      >
        {EFFORT_OPTIONS.map((o) => (
          <MenuItem key={o.id} value={o.id} sx={{ display: 'block', maxWidth: 300, whiteSpace: 'normal' }}>
            <div style={{ fontWeight: 600, fontSize: 13 }}>{o.label}</div>
            <div style={{ fontSize: 11.5, opacity: 0.7, lineHeight: 1.35 }}>{o.hint}</div>
          </MenuItem>
        ))}
      </TextField>
    </Tooltip>
  );
};
